  export default new Proxy({}, {
    get(_, key) {
      throw new Error(`Module "url" has been externalized for browser compatibility. Cannot access "url.${key}" in client code.  See https://vite.dev/guide/troubleshooting.html#module-externalized-for-browser-compatibility for more details.`)
    }
  })